{
    "PreviewHeader": "Vorschau",
    "PreviewValueInvalid": "[Ungültiges Format]",
    "NAME": "Preview"
}